import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setIncludeCanvasHangerKitReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.includeCanvasHangerKit = action.payload;
};

export default setIncludeCanvasHangerKitReducer;
